<span class="badge badge-{{!color ? classes[status] : 'nocolor'}}-light" style="--color: {{color}}; --background: {{color}}33;">{{status | status}}</span>